<i18n>
{
  "en": {
  },
  "fr": {
  }
}
</i18n>
<template>
  <v-alert :type="internalOptions.type" v-model="internalShow">
    <div v-for="message in internalMessages" :key="message">
      {{ message }}
    </div>
  </v-alert>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({
        type: 'error'
      })
    }
  },
  watch: {
    messages: {
      immediate: true,
      handler: function (value, oldVal) {
        this.internalMessages = value
        if (this.internalMessages && this.internalMessages.length > 0) {
          this.internalShow = true
        } else {
          this.internalShow = false
        }
      }
    },
    options: {
      immediate: true,
      handler: function (value, oldVal) {
        if (value) {
          this.internalOptions = value
        } else {
          this.internalOptions = {
            type: 'error'
          }
        }
      }
    }
  },
  data: () => ({
    internalMessages: [],
    internalShow: false,
    internalOptions: {
    }
  })
}
</script>

<style>

</style>
